import BookmarkAddOutlined from "@mui/icons-material/BookmarkAddOutlined";
import BookmarkAddedOutlined from "@mui/icons-material/BookmarkAddedOutlined";
import { IconButton } from "@mui/material";
import { useTranslation } from "react-i18next";
import { useWarehouseLabelBuffer } from "../../../../../../contexts/WarehouseLabelBuffer";

// "Add to label print queue" toggle for an opened item - same buffer as the
// table row checkbox (WarehouseTable.jsx), just placed next to the QR
// section in the item's header (WarehouseItemDetailsDialog.jsx / WarehouseItemPage.jsx).
export default function WarehouseLabelBufferToggle({ item }) {
  const { t } = useTranslation();
  const { isBuffered, toggle } = useWarehouseLabelBuffer();
  const buffered = isBuffered(item.id);

  return (
    <IconButton
      onClick={() => toggle(item)}
      title={t(buffered ? "RemoveFromLabelQueue" : "AddToLabelQueue")}
      size="small"
    >
      {buffered ? (
        <BookmarkAddedOutlined fontSize="small" color="primary" />
      ) : (
        <BookmarkAddOutlined fontSize="small" />
      )}
    </IconButton>
  );
}
